<script setup>
const props = defineProps({
  content: {
    type: Object,
    default: () => ({})
  },
  rank: {
    type: Number,
    default: null
  }
})
const isImageError = ref(false)
const url = `https://gvs.weathernews.jp/golf/image/golf_info_image/golf_${props.content.golf_id}/1.webp`
const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const checkImageExists = async (url) => {
  const response = await fetch(url, { method: 'HEAD' })
  if (!response.ok) {
    isImageError.value = true
  }
}

checkImageExists(url)
</script>

<template>
  <NuxtLink
    class="golfRecommendItem"
    :to="`${isWebViewFlag ? `${runtimeConfig.app.baseURL}${content.wni_url}/` : `/${content.wni_url}/`}`"
    :external="isWebViewFlag"
  >
    <p
      class="name"
      :data-rank="rank"
    ><span
      v-if="rank>3"
      class="rank-tag"
    >{{ rank }}</span>{{ content.name.replace(/[（/]旧.*$/, '') }}</p>
    <div class="content">
      <div class="image">
        <figure class="appearance">
          <img
            v-if="!isImageError"
            :src="url"
            alt=""
            loading="lazy"
          >
          <img
            v-if="isImageError"
            src="https://gvs.weathernews.jp/golf/image/golf_info_image/noimage.webp"
            alt=""
            loading="lazy"
          >
        </figure>
        <p class="pref">
          {{ content.pref_name.replace(/(都|府|県)$/, '') }}
        </p>
      </div>
      <div class="textarea">
        <div>
          <p class="address">
            {{ content.postal }}
          </p>
          <p class="address">
            {{ content.address }}
          </p>
        </div>
        <p class="access">
          {{ content.access }}
        </p>
        <div class="info">
          <div class="item">
            <p class="title">
              ホール数
            </p>
            <p class="text">
              {{ String(content.number_of_hole) }}
            </p>
          </div>
          <div class="item">
            <p class="title">
              パー
            </p>
            <p class="text">
              {{ String(content.par) }}
            </p>
          </div>
          <div class="item">
            <p class="title">
              コース状況
            </p>
            <p class="text">
              {{ content.state_of_course }}
            </p>
          </div>
          <div class="item">
            <p class="title">
              面積
            </p>
            <p class="text">
              {{ String(content.dimensions) }}㎡
            </p>
          </div>
          <div class="item">
            <p class="title">
              距離
            </p>
            <p class="text">
              {{ String(content.yardage) }}Y
            </p>
          </div>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.golfRecommendItem {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .name {
    position: relative;
    padding: 5px 0 1px 35px;
    background-position: left center;
    background-size: 30px;
    background-repeat: no-repeat;
    color: #000;
    font-size: 20px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: .25px;
    &[data-rank="1"] {
      background-image: url('https://gvs.weathernews.jp/golf/image/rank/icon_rank_1.svg');
    }
    &[data-rank="2"] {
      background-image: url('https://gvs.weathernews.jp/golf/image/rank/icon_rank_2.svg');
    }
    &[data-rank="3"] {
      background-image: url('https://gvs.weathernews.jp/golf/image/rank/icon_rank_3.svg');
    }
    .rank-tag {
      position: absolute;
      top: 0;
      left: 0;
      padding-top: 6px;
      padding-bottom: 6px;
      color: #FFF;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 1em;
      width: 27px;
      height: 27px;
      background-color: #3569C0;
      border-radius: 5px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
  .image {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 310px;
    width: 100%;
  }
  .appearance {
    width: 100%;
    aspect-ratio: 310 / 180;
    img {
      width: 100%;
    }
  }
  .pref {
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 10px;
    padding-bottom: 9px;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 1em;
    width: 68px;
    background-color: #3569C0;
  }
  .type {
    position: absolute;
    right: 10px;
    bottom: 10px;
    border-radius: 4px;
    overflow: hidden;
    background-color: rgb(0 0 0 / .2);
    figure {
      padding: 5px;
    }
    p {
      padding-top: 3px;
      padding-top: 2px;
      background-color: #fff;
      color: #000;
      font-size: 12px;
      line-height: 1em;
      letter-spacing: 0.25px;
      text-align: center;
    }
  }
  .textarea {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
  }
  .address {
    color: #000;
    font-size: 16px;
    line-height: 1.4em;
  }
  .access {
    color: #000;
    font-size: 15px;
    line-height: 1.4em;
  }
  .info {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  .item {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 2px 5px 2px 2px;
    background-color: #F0F3F9;
    .title {
      padding: 3px;
      color: #363636;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      line-height: 15px;
      background-color: #fff;
    }
    .text {
      color: #363636;
      font-size: 13px;
      font-weight: 400;
      line-height: 15px;
    }
  }
  @media (any-hover: hover) {
    transition: opacity .2s ease-in-out;
    &:hover {
      opacity: .6;
    }
  }
}
@media screen and (min-width: 830px) {
  .golfRecommendItem {
    padding-right: 25px;
    background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_arrow_blue.svg');
    background-position: right 4px center;
    background-repeat: no-repeat;
    background-size: 15px;
    .content {
      flex-direction: row;
      align-items: flex-start;
    }
    .image {
      width: 40%;
    }
  }
}
</style>
